
export class RemoveEventInput {
    eventId: string;
    leadId: string;
}
